// Общие данные
import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    busy: false,
    lastMessage: '',
    lastError: '',
    lastErrorCode: '',
    currentUser: {
        uuid: null,
        originalData: {
            name: '',
        },
        data: {
            name: '',
            roles: [],
        },
        changes: {}
    },
    currentUserCalendar: {}, // Календарь для текущего пользователя с его аппоинтментами
    userRole: 'CLIENT',
    // roles: [],
    // Мы не не можем перемещаться между вложенными уровнями навигации.
    //   Чтобы переместится на страницу редактирования данных сотрудника EmployeePersonEdit из клиентской страницы, когда он становится сотрудникомм
    //   нам надо установить homeNavigateTo в 'EmployeePersonEdit' и переместитсян в EmployeeHome 
    //   а каждая домашняя страница (со временем) начнет анаизировать homeNavigateTo и перемещаться в нее.
    homeNavigateTo: '',
    hideDrawer: false,
    notification: null,
    forceNavigateTo: '',
    becameOwner: false,
};

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setBusy: (state, action) => {
            state.busy = action.payload;
        },
        setLastMessage: (state, action) => {
            state.lastMessage = action.payload;
        },
        setLastError: (state, action) => {
            state.lastError = action.payload;
        },
        setLastErrorCode: (state, action) => {
            state.lastErrorCode = action.payload;
        },
        setLastErrorData: (state, action) => {
            state.lastError = action.payload.error;
            state.lastMessage = action.payload.message;
            state.lastErrorCode = action.payload.code;
        },
        setUserRole: (state, action) => {
            state.userRole = action.payload;
        },
        setRoles: (state, action) => {
            state.currentUser.data.roles = action.payload;
        },
        clearLastErrorData: (state, action) => {
            state.lastError = '';
            state.lastMessage = '';
            state.lastErrorCode = '';
        },
        setCurrentUser: (state, action) => {
            state.currentUser.originalData = action.payload;
            state.currentUser.data = action.payload;
            state.currentUser.changes = {};
        },
        modifyCurrentUser: (state, action) => {
            state.currentUser.changes = {
                ...state.currentUser.changes,
                ...action.payload,
            };
            state.currentUser.data = {
                ...state.currentUser.data,
                ...action.payload,
            };
        },
        setHomeNavigateTo: (state, action) => {
            state.homeNavigateTo = action.payload;
        },
        setHideDrawer: (state, action) => {
            state.hideDrawer = action.payload;
        },
        setNotification: (state, action) => {
            state.notification = action.payload;
        },
        setForceNavigateTo: (state, action) => {
            state.forceNavigateTo = action.payload;
        },
        setCurrentUserCalendar: (state, action) => {
            if (action.payload != null) {
                for (let date in action.payload) {
                    const calendarResponse = action.payload[date];
                    state.currentUserCalendar[date] = {
                        date: date,
                        schedule: calendarResponse.scheduleList,                                // Расписание рабочих часов на день (список, но пока из одного элемента)
                        appointments: calendarResponse.appointmentList,                         // Назначения на день
                        level: calendarResponse.level,                         // Назначения на день
                    };
                }
            }
        },
        setBecameOwner: (state, action) => {
            state.becameOwner = action.payload;
        },
    },
});

export const {
    setBusy,
    setLastMessage,
    setLastError,
    setLastErrorCode,
    setLastErrorData,
    clearLastErrorData,
    setCurrentUserCalendar,
    setBecameOwner,
    setCurrentUser,
    setUserRole,
    setRoles,
    setHomeNavigateTo,
    modifyCurrentUser,
    setHideDrawer,
    setNotification,
    setForceNavigateTo
} = commonSlice.actions;

export const getBusy = (state) => state.common.busy;
export const getUserRole = (state) => state.common.userRole;
export const getLastMessage = (state) => state.common.lastMessage;
export const getLastError = (state) => state.common.lastError;
export const getLastErrorCode = (state) => state.common.lastErrorCode;
export const getCommon = (state) => state.common;
export const getCurrentUser = (state) => state.common.currentUser.data;
export const getHomeNavigateTo = (state) => state.common.homeNavigateTo;
export const getHideDrawer = (state) => state.common.hideDrawer;
export const getNotification = (state) => state.common.notification;
export const getForceNavigateTo = (state) => state.common.forceNavigateTo;
export const getBecameOwner = (state) => state.common.becameOwner;

export const getCurrentUserCalendar = (state) => state.common.currentUserCalendar;                    // Расписание и назначения по датам:


export default commonSlice.reducer;